import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { target: String }
  scrollTo() {
    document.querySelector(this.targetValue)?.scrollIntoView({ behavior: 'smooth' })
  }
}
